import { render, staticRenderFns } from "./ModalDistribution.vue?vue&type=template&id=2d7078db"
import script from "./ModalDistribution.js?vue&type=script&lang=js&external"
export * from "./ModalDistribution.js?vue&type=script&lang=js&external"
import style0 from "./ModalDistribution.vue?vue&type=style&index=0&id=2d7078db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports